import { useAbility } from '@casl/react';
import { useQuery } from '@tanstack/react-query';
import { AbilityContext } from 'components/can';
import { Grid, Loader } from 'components/ui';
import { useApiReady } from 'hooks/use-api-ready';
import { useOrgConfig } from 'hooks/use-org-config';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { useMedia } from 'react-use';
import { breakpoints } from 'styles/breakpoints';
import { SummaryCard } from './summary-card';
import { SummaryMobileCard } from './summary-mobile-card';

export const BookingSummaryCard = () => {
  const isMobile = useMedia(`(max-width: ${breakpoints.medium})`, false);
  const apiReady = useApiReady();
  const orgId = useStore((store) => store.activeBuyerOrgId);
  const ability = useAbility(AbilityContext);
  const canRead = ability.can('read', 'Stockbook');

  const { isLoading, data: activeFields } = useOrgConfig();

  const { isLoading: weeklyLoading, data: weeklyData } = useQuery(
    ['weeklyData', orgId],
    () =>
      new ApiClient().reportsApi.orgReportBookingWeeklyList({
        buyerOrgId: orgId || '',
      }),
    { enabled: apiReady && !!orgId }
  );

  if (isLoading && weeklyLoading) {
    return <Loader />;
  }
  if (canRead) {
    return (
      <>
        {isMobile ? (
          <>
            {activeFields?.products.map((product, index: number) => {
              return (
                <SummaryMobileCard
                  key={index}
                  name={`${product.name} booking summary` || ''}
                  details={weeklyData?.data as []}
                  productId={product.product_id}
                />
              );
            })}
          </>
        ) : (
          <Grid auto={{ min: '420px' }} gap={1}>
            {activeFields?.products.map((product, index: number) => {
              return (
                <SummaryCard
                  key={index}
                  name={`${product.name} booking summary` || ''}
                  productId={product.product_id}
                  details={weeklyData?.data}
                />
              );
            })}
          </Grid>
        )}
      </>
    );
  } else {
    return null;
  }
};
